import { d as dispatchToTrackersInCollection, c as addEventListener, b as buildSelfDescribingEvent, i as isFunction } from "./index-CXOWMkTi.js";
/*!
 * Error tracking for Snowplow v3.23.1 (http://bit.ly/sp-js)
 * Copyright 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * Licensed under BSD-3-Clause
 */
var _trackers = {};
function ErrorTrackingPlugin() {
  return {
    activateBrowserPlugin: function(tracker) {
      _trackers[tracker.id] = tracker;
    }
  };
}
function trackError(event, trackers) {
  if (trackers === void 0) {
    trackers = Object.keys(_trackers);
  }
  var message = event.message, filename = event.filename, lineno = event.lineno, colno = event.colno, error = event.error, context = event.context, timestamp = event.timestamp, stack = error && error.stack ? error.stack : null;
  dispatchToTrackersInCollection(trackers, _trackers, function(t) {
    t.core.track(buildSelfDescribingEvent({
      event: {
        schema: "iglu:com.snowplowanalytics.snowplow/application_error/jsonschema/1-0-1",
        data: {
          programmingLanguage: "JAVASCRIPT",
          message: message !== null && message !== void 0 ? message : "JS Exception. Browser doesn't support ErrorEvent API",
          stackTrace: stack,
          lineNumber: lineno,
          lineColumn: colno,
          fileName: filename
        }
      }
    }), context, timestamp);
  });
}
function enableErrorTracking(configuration, trackers) {
  if (configuration === void 0) {
    configuration = {};
  }
  if (trackers === void 0) {
    trackers = Object.keys(_trackers);
  }
  var filter = configuration.filter, contextAdder = configuration.contextAdder, context = configuration.context, captureError = function(errorEvent) {
    if (filter && isFunction(filter) && filter(errorEvent) || filter == null) {
      sendError({ errorEvent, commonContext: context, contextAdder }, trackers);
    }
  };
  addEventListener(window, "error", captureError, true);
}
function sendError(_a, trackers) {
  var errorEvent = _a.errorEvent, commonContext = _a.commonContext, contextAdder = _a.contextAdder;
  var context = commonContext || [];
  if (contextAdder && isFunction(contextAdder)) {
    context = context.concat(contextAdder(errorEvent));
  }
  trackError({
    message: errorEvent.message,
    filename: errorEvent.filename,
    lineno: errorEvent.lineno,
    colno: errorEvent.colno,
    error: errorEvent.error,
    context
  }, trackers);
}
export {
  ErrorTrackingPlugin,
  enableErrorTracking,
  trackError
};
